import { IApplicationContext } from '../../../types/application-context';
import { EGalleryLabelColor, IGalleryLabel } from '../../../types/gallery-label';

export function getAgentListsLabels(agentLists: string[], ctx: Pick<IApplicationContext, 'config'>): IGalleryLabel[] {
  const agentListsMap = ctx.config.get<Record<string, string>>('sellingTypes.agentLists');

  if (!agentListsMap) {
    return [];
  }

  const result = [];

  for (const agentList of agentLists) {
    const labelText = agentListsMap[agentList];

    if (labelText) {
      result.push({
        color: EGalleryLabelColor.LightGrey,
        label: labelText,
      });
    }
  }

  return result;
}
